import { useSession } from '@clerk/nextjs';
import { PresetCreate, PresetUpdate } from '../types';
import { BASE_URL, createHeaders } from '../utils';

export async function getRecentLivestreams(cursor?: string, limit: number = 8) {
  if (limit < 1 || limit > 10) {
    throw new Error('Limit must be between 1 and 10');
  }

  const headers = await createHeaders();
  const url = new URL(`${BASE_URL}/get-recent-livestreams`);
  if (cursor) url.searchParams.append('cursor', cursor);
  url.searchParams.append('limit', limit.toString());

  const response = await fetch(url.toString(), {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function getLiveHighlightsWithUrls(livestreamId: string) {
  const response = await fetch(`${BASE_URL}/get-live-highlights-with-urls/${livestreamId}`, {
    method: 'GET',
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}

export async function getLivestreamInfo(livestreamId: string) {
  const headers = await createHeaders();
  const response = await fetch(`${BASE_URL}/livestream-info/${livestreamId}`, {
    method: 'GET',
    headers,
  });

  if (!response.ok) {
    throw new Error(`Request failed with status ${response.status}`);
  }

  return response.json();
}